import { type SmartHomeScheme } from '../types';

export const smartHomeScheme: SmartHomeScheme = {
  categories: [
    {
      backgroundImageSrc:
        'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/smart-home/electricity-and-light.webp',
      cards: [
        {
          imageAlt: 'Мастер-выключатель электричества',
          imageSrc:
            'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/smart-home/master-switch.webp',
          title: 'Мастер-выключатель электричества',
        },
        {
          imageAlt: 'Розетка для умного привода штор',
          imageSrc:
            'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/smart-home/curtains-socket.webp',
          title: 'Розетка для умного привода штор',
        },
        {
          imageAlt: 'Реле для управления освещением',
          imageSrc: 'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/smart-home/light-relay.webp',
          title: 'Реле для управления освещением',
        },
      ],
      chipsOption: {
        dataTestId: 'smart-home-category-chip-electricity-and-light',
        label: 'Электрика и свет',
        value: 'electricity-and-light',
      },
      description: [
        'В квартире уже установлены мастер-выключатель',
        'электричества, реле для управления освещением',
        'и розетка для умного привода штор.',
        '',
        'Всё это можно настраивать удалённо —',
        'для комфорта и экономии ресурсов.',
      ],
      id: 'electricity-and-light',
    },
    {
      backgroundImageSrc:
        'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/smart-home/leak-protection.webp',
      cards: [
        {
          imageAlt: 'Датчик протечки воды',
          imageSrc:
            'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/smart-home/water-leak-sensor.webp',
          title: 'Датчик протечки воды',
        },
        {
          imageAlt: 'Умный кран',
          imageSrc:
            'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/smart-home/smart-faucet.webp',
          title: 'Умный кран',
        },
      ],
      chipsOption: {
        dataTestId: 'smart-home-category-chip-leak-protection',
        label: 'Защита от протечек',
        value: 'leak-protection',
      },
      description: [
        'Система с датчиком и умным краном реагирует',
        'на воду и перекрывает её подачу.',
        '',
        'Это защищает вас и соседей от затоплений, даже',
        'если вас нет дома.',
      ],
      id: 'leak-protection',
    },
    {
      backgroundImageSrc:
        'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/smart-home/microclimate.webp',
      cards: [
        {
          imageAlt: 'Датчик температуры и влажности',
          imageSrc:
            'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/smart-home/temperature-and-humidity-sensor.webp',
          title: 'Датчик температуры и влажности',
        },
        {
          imageAlt: 'Электронный термостат для радиатора',
          imageSrc:
            'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/smart-home/radiator-thermostat.webp',
          title: 'Электронный термостат для радиатора',
        },
        {
          imageAlt: 'Терморегулятор тёплого пола',
          imageSrc:
            'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/smart-home/floor-heating-thermostat.webp',
          title: 'Терморегулятор тёплого пола',
        },
      ],
      chipsOption: {
        dataTestId: 'smart-home-category-chip-microclimate',
        label: 'Микроклимат',
        value: 'microclimate',
      },
      description: [
        'Комфорт в квартире обеспечивает система датчиков',
        'и регуляторов.',
        '',
        'Управляйте отоплением, тёплым полом',
        'и кондиционером с помощью голоса, по расписанию или через приложение.',
      ],
      id: 'microclimate',
    },
    {
      backgroundImageSrc:
        'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/smart-home/control-devices.webp',
      cards: [
        {
          imageAlt: 'Универсальный хаб',
          imageSrc:
            'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/smart-home/universal-hub.webp',
          title: 'Универсальный хаб',
        },
        {
          imageAlt: 'Датчик открытия двери',
          imageSrc:
            'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/smart-home/door-opening-sensor.webp',
          title: 'Датчик открытия двери',
        },
      ],
      chipsOption: {
        dataTestId: 'smart-home-category-chip-control-devices',
        label: 'Устройства управления',
        value: 'control-devices',
      },
      description: [
        'Все элементы умного дома объединяются в систему',
        'с помощью хаба. Управляйте ими голосом или через',
        'приложение.',
        '',
        'Другие устройства — например, датчик открытия',
        'двери — делают дом ещё удобнее.',
      ],
      id: 'control-devices',
    },
  ],
  id: 'smart-home',
  sectionTabTitle: 'Умный дом',
  title: 'Умный дом',
};
